import { fetchPostWeb } from 'eco-design-micro/request2/FetchClient';
import { getWebToken } from 'eco-design-micro/utils-user/web/webToken';

export const getGloAIProductList = async (params: any, locale: string) => {
    const tokenA = getWebToken(locale);
    return await fetchPostWeb(`/website/aiSearch`, params, {
        locale,
        token: tokenA,
    });
};
